// extracted by mini-css-extract-plugin
export default {"warningText":"freeDeliveryWarning-module__warningText--x_NY_"};